import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleCheck, faFileLines } from "@fortawesome/pro-solid-svg-icons"
import cx from "classnames"

import WizardCard from "../../components/WizardCard"
import CheckmarkListItem from "../../components/CheckmarkListItem"

export interface LiabilityInsuranceQuoteCardProps {
  badge?: string
  className?: string
  eyebrow: string
  heading: string
  subheading: string
  list: string[]
  annualPremium: string | undefined
  summary: string
}

const LiabilityInsuranceQuoteCard = ({
  badge,
  className,
  eyebrow,
  heading,
  subheading,
  list,
  annualPremium,
  summary,
}: LiabilityInsuranceQuoteCardProps) => (
  <WizardCard>
    <div
      className={cx("relative h-full p-6", className)}
      data-testid="liability-insurance-quote-card"
    >
      <div className="relative h-full flex flex-col">
        <p className="flex items-center text-overline gap-2">
          {eyebrow}
          {badge ? (
            <span className="text-autumn italic normal-case">[{badge}]</span>
          ) : null}
        </p>

        <h3 className="flex justify-between gap-2 text-leaf text-2xl font-display font-medium leading-[30px] tracking-[0.48px] mt-2">
          {heading}

          <span className="h-[30px] self-baseline flex items-center justify-center">
            <FontAwesomeIcon icon={faCircleCheck} />
          </span>
        </h3>

        <p className="text-dusk-500 font-body leading-[140%] tracking-[0.32px] mt-2">
          {subheading}
        </p>

        <ul className="grid grid-cols-1 gap-5 mt-[26px] mb-8">
          {list.map((item) => (
            <CheckmarkListItem key={item}>{item}</CheckmarkListItem>
          ))}
        </ul>

        <hr className="border-cloud-500 mb-4 mt-auto" />

        <div className="flex flex-col gap-4 mt-2">
          <div>
            <h4 className="flex justify-between text-xl font-display font-medium leading-[124%] tracking-[0.48px]">
              <span>Annual Premium</span>
              <span>{annualPremium}</span>
            </h4>

            <p className="text-dusk-500 font-body leading-[140%] tracking-[0.32px] mt-2">
              {summary}
            </p>

            <p className="text-dusk-500 font-body text-sm leading-[140%] tracking-[0.32px] mt-1">
              Minimum premium $225
            </p>
          </div>

          <div className="bg-cloud-300 rounded p-2">
            <p className="text-dusk-500 font-body text-xs leading-[140%] tracking-[0.32px]">
              Please note this policy is fully earned at time of inception - No
              refunds will be issued if the policy is cancelled midterm.
            </p>
          </div>

          <a
            href="https://ncx-platform-public.s3.us-east-1.amazonaws.com/insurance/Timberland_Certificate_Sample.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="self-start link hover:cursor-pointer"
            data-testid="view-sample-certificate-of-insurance-link"
          >
            <FontAwesomeIcon icon={faFileLines} className="mr-2" />
            View sample certificate of insurance
          </a>
        </div>
      </div>
    </div>
  </WizardCard>
)

export default LiabilityInsuranceQuoteCard
